<template>
  <div class="work-order-wrapper">
    <h-msg-box
      title="提交工单"
      v-model="workOrderShow"
      class-name="vertical-center-modal"
      :top="100"
      width="600"
      height="380"
    >
      <h-form
        ref="formItem"
        :model="formItem"
        :label-width="150"
        errorFocus
        cols="1"
        label-position="right"
        :rules="ruleValidate"
      >
        <h-form-item
          label="类型"
          required
          style="margin-bottom:8px;"
          prop="feedback_type"
        >
          <h-select
            v-model="formItem.feedback_type"
            style="width:300px;"
            setDefSelect
          >
            <h-option
              key="feedback3"
              value="3"
            >需求</h-option>
            <h-option
              key="feedback2"
              value="2"
            >建议</h-option>
            <h-option
              key="feedback1"
              value="1"
            >问题</h-option>
          </h-select>
        </h-form-item>
        <h-form-item
          label="联系人"
          style="margin-bottom:8px;"
          prop="contact_name"
        >
          <h-input
            style="width:300px;"
            v-model="formItem.contact_name"
          ></h-input>
        </h-form-item>
        <h-form-item
          label="联系电话"
          style="margin-bottom:8px;"
          prop="contact_phone"
        >
          <h-input
            style="width:300px;"
            v-model="formItem.contact_phone"
          ></h-input>
        </h-form-item>
        <h-form-item
          label="具体描述"
          required
          style="margin-bottom:8px;"
          prop="content"
        >
          <h-input
            style="width:300px;"
            :rows="4"
            v-model="formItem.content"
            type="textarea"
            :maxlength=500
            :showWordLimit="true"
          ></h-input>
        </h-form-item>
        <h-form-item
          label="提交人手机"
          required
          style="margin-bottom:8px;"
          v-if="!login"
          prop="phone"
        >
          <h-input
            style="width:300px;"
            v-model="formItem.phone"
          ></h-input>
        </h-form-item>
        <h-form-item
          label="验证码"
          required
          style="margin-bottom:8px;"
          v-if="!login"
          prop="checkcode"
        >
          <h-input
            style="width:190px;"
            v-model="formItem.checkcode"
          ></h-input>
          <span
            style="color: #00aaee;margin-left: 10px;cursor:pointer;"
            @click="getCheckCode"
            ref="veBtn"
          >获取验证码</span>
        </h-form-item>
      </h-form>
      <p
        slot="footer"
        class="message-bottom"
      >
        <h-button
          type="primary"
          @click="workOrderOk"
        >确定</h-button>
        <h-button
          type="ghost"
          @click="workOrderCancel"
        >取消</h-button>
      </p>
    </h-msg-box>
  </div>
</template>
<script>
import fetch from '@/api/httpFetch.js'
import Emitter from '@/utils/emitter';
import axios from 'axios'
import Qs from 'qs'
import store from '@/store'
export default {
  name: 'createForm',
  data() {
    const validatePhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('商机提交人手机不能为空'));
      } else {
        if (!/^1([358][0-9]|4[579]|66|7[0135678]|9[89])[0-9]{8}$/.test(Number(value))) {
          return callback(new Error('输入格式不正确'));
        } else {
          callback();
        }
      }
    };
    const validateCheckcode = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('验证码不能为空'));
      } else {
        callback();
      }
    };
    return {
      workOrderShow: false,
      formItem: {},
      //login:store.getters.user.hsid?true:false,
      ruleValidate: {
        phone: [
          { validator: validatePhone, trigger: 'blur' }
        ],
        checkcode: [
          { validator: validateCheckcode, trigger: 'change' }
        ]
      },
      tjFlag: true
    }
  },
  props: {

  },
  computed: {
    login() {
      return store.getters.user.hsid ? true : false;
    }
  },
  methods: {
    workOrderOk() {
      this.$refs['formItem'].validate((valid) => {
        if (valid) {
          axios({
            url: '/cloud/open/feedback/addFeedbackInfo.json',
            data: Qs.stringify(this.formItem),
            method: 'post',
            headers: { 'content-type': 'application/x-www-form-urlencoded;charset=UTF-8' },
            withCredentials: true
          }).then(res => {
            // ;
            if (res.data.error_info) {
              this.$hMessage.error(res.data.error_info);
            } else {
              this.$hMessage.success('提交成功');
              this.workOrderShow = false;
              this.formItem = {};
            }
          })
        }

      })
    },
    workOrderCancel() {
      // this.workOrderCancel = false;
      this.workOrderShow = false;
    },
    getCheckCode() {
      if (this.tjFlag) {
        this.tjFlag = false;
        this.count();
        let params = {
          phone: this.formItem.phone
        }
        axios({
          url: '/cloud/open/getCheckCode.json',
          data: Qs.stringify(params),
          method: 'post',
          headers: { 'content-type': 'application/x-www-form-urlencoded;charset=UTF-8' },
          withCredentials: true
        }).then(res => {
          if (res.data.error_info) {
            this.$hMessage.error(res.data.error_info);
          } else {
            //this.$hMessage.success('提交成功');
            this.count();
          }
        })
      }

    },
    count() {
      let countdown = 60, dom = this.$refs.veBtn, _this = this;
      function countDown() {
        if (countdown == 0) {
          clearInterval(_this.tjInter);
          _this.tjFlag = true;
          countdown = 60;
          //dom.css("cursor","pointer");
          //dom.css("color",color);
          _this.$refs.veBtn.style.cursor = "pointer";
          _this.$refs.veBtn.style.color = "#00aaee";
          _this.$refs.veBtn.innerText = "获取验证码";
        } else {
          _this.tjFlag = false;
          countdown--;
          //修复Bug不用显示0s
          if (countdown == 0) {
            return false;
          }
          //dom.css("color","#656e8c");
          //dom.css("cursor","default");
          _this.$refs.veBtn.style.cursor = "default";
          _this.$refs.veBtn.style.color = "#aeb1b2";
          _this.$refs.veBtn.innerText = countdown + 's后获取';
        }
      }
      this.tjInter = setInterval(function () { countDown() }, 1000);
    }
  },
  created() {
  },
  mounted() {

  }
}
</script>
<style>
.message-bottom {
  display: flex;
  justify-content: space-around;
  width: 200px;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/gtn/views/frontViews/components/createWorkOrder.vue